var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHelpActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2242_5928)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#E3F1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 31.5C25.4558 31.5 31.5 25.4558 31.5 18C31.5 10.5442 25.4558 4.5 18 4.5C10.5442 4.5 4.5 10.5442 4.5 18C4.5 25.4558 10.5442 31.5 18 31.5Z",
    stroke: "#141C25",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 25.5V25.5173",
    stroke: "#141C25",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 20.25C17.9724 19.7631 18.1037 19.2803 18.3743 18.8745C18.6448 18.4687 19.0399 18.1618 19.5 18C20.0638 17.7844 20.5699 17.4409 20.9784 16.9964C21.3868 16.552 21.6866 16.0188 21.854 15.4389C22.0214 14.8589 22.0519 14.248 21.9431 13.6543C21.8343 13.0606 21.5891 12.5002 21.227 12.0173C20.8648 11.5344 20.3955 11.1421 19.8559 10.8714C19.3164 10.6007 18.7214 10.459 18.1178 10.4573C17.5142 10.4556 16.9184 10.5941 16.3774 10.8618C15.8363 11.1295 15.3649 11.5191 15 12",
    stroke: "#141C25",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2242_5928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpActive);
export default __webpack_public_path__ + "static/media/Icon_Help_Active.e3b3e9c6008ae9654615c9b07100b328.svg";
export { ForwardRef as ReactComponent };